// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// The project's data and its upload say the same words (AUT-6630 upload copy): the Imagery and Point Clouds panel's
// heading, its upload control and this dialog's heading. The area has its own upload in Your Area.
export const DATA_NAME = 'Imagery and Point Clouds';
const IMAGERY_ONLY_NAME = 'Imagery';

export const DATA_UPLOAD_NAME = `Upload ${DATA_NAME}`;

// An account that may upload .tif/.tiff only (editorFunctions without placeOrder) is told what it can upload.
export const IMAGERY_ONLY_UPLOAD_NAME = `Upload ${IMAGERY_ONLY_NAME}`;

export const dataUploadHeading = (acceptedExtensions?: string[]): string => (
  acceptedExtensions?.some((extension) => extension === '.las' || extension === '.laz')
    ? DATA_UPLOAD_NAME
    : IMAGERY_ONLY_UPLOAD_NAME
);
